import React, { FC } from 'react';
import { Stalled, StalledContent } from 'QuoteApp/components';

export const InMoratorium: FC = () => {
  return (
    <Stalled testId="aqui-moratorium-status-screen">
      <StalledContent variant="headline">
        This customer’s area is currently under a moratorium
      </StalledContent>
      <StalledContent>
        We’re temporarily unable to provide a quote due to extreme conditions in
        this customer’s area. No new policies may be written until the
        moratorium is lifted.
      </StalledContent>
    </Stalled>
  );
};
